import { buildScopedI18n } from '../../../../utils/buildScopedI18n';
import configTasksEsCL from './locales/es-CL.json';
import configTasksEnUS from './locales/en-US.json';
import configTasksPtBR from './locales/pt-BR.json';

export const configTasksI18n = buildScopedI18n({
  esCL: configTasksEsCL,
  enUS: configTasksEnUS,
  ptBR: configTasksPtBR,
});
